import { Request } from "@/plugin/axios";
import api from "@/constant/api/dashboard/devops/index.js";
const jsonOptions = {
  headers: {
    "Content-Type": "application/json"
  }
};
// 健康系统与升级
export function getSystemHealth(code) {
  return Request(api.getSystemHealth, api.getSystemHealth.url + code, jsonOptions);
}
